export default {
	"leon": {
		"name": "leon",
		"basic": {
			"default": "#1DAA6C",
			"font": "#fff",
			"darkMode": "#8cb7ef"
		},
		"banner_intermediacion": false,
		"button": {
			"default": "#1DAA6C",
			"font": "#fff",
			"darkMode": "#8cb7ef"
		},
		"soft_basic": {
			"default": "#9bb5d6",
			"dark": "#9bb5d6"
		},
		"text_black": {
			"default": "#202020",
			"darkMode": "#ffffff"
		},
		"dark_black": {
			"default": "#4a4a4a",
			"darkMode": "#f3f3f3"
		},
		"medium_black": {
			"default": "#9b9b9b",
			"dark": "#f4f4f4"
		},
		"soft_black": {
			"default": "#d8d8d8",
			"dark": "#0c0c0c"
		},
		"light_black": {
			"default": "#f2f2f2",
			"dark": "#333"
		},
		"white": {
			"default": "#fff",
			"darkMode": "#222"
		},
		"hasFavicon": true,
		"logo": "/static/img/brands/leon/logo-color-blanco.svg",
		"logocolor": "/static/img/brands/leon/logo-color-blanco.svg",
		"logodarkmode": "/static/img/brands/leon/logo-color-blanco.svg",
		"logoSize": "medium",
		"background": "/static/img/brands/leon/background.jpg",
	
		"emailContacto": "coie@unileon.es",
		"emailProblemas": "coie@unileon.es",
		"analitycs": "",
		"dominio_produccion": "",
		"portal_publico": "",
		"ownpopup_info": {
			"uso_logo": {
				"titulo": "Autorizo el uso de la imagen de la empresa",
				"texto": "Si autorizas, tenemos tu permiso para mostrar la imagen del logo de la empresa en el portal de candidatos/as y en la web pública de empleo de Programa Clave USAL. Aunque autorices ahora, cuando crees ofertas podrás configurar si quieres que se muestren o no, vinculados a esa oferta, los datos de tu empresa."
			}
		},
		
		"footer": {
			"textos": ["Copyright © {year} - Universidad de León"],
			"links": {
				"Aviso Legal": "https://www.unileon.es/aviso-legal",
				// "Política de Cookies": "",
				"Política de privacidad": "https://www.unileon.es/politica-de-privacidad"
			}
		},
		"fonts": {
			"link": "family=Open%20Sans:400,500,700",
			"principal": "'Open Sans', sans-serif",
			"secundaria": "'Open Sans', sans-serif"
		},
		"ownstyles": "/static/img/brands/usal/style.css",
		"logintexts": {
			"antiguos": "Antiguos Alumnos",
			"estudiantes": "EMPLEO/PRÁCTICAS NO LABORALES​",
			"empresas": "EMPRESAS / ENTIDADES COLABORADORAS",
			"estudiantes_ule": "ESTUDIANTES ULE"
		},

		"mostrarAdhesion": true,
		"urlPortalTutores": "",

		//PROPUESTA DE PRÁCTICAS
		
		"showPropuestaPracticas": true,
		"requestProgramaPracticas": true,
		"hasProgramaPracticasActivo": true,
		"hasProgramaPracticasInHome": true,
		"requestDatosFirmanteEnPropuesta": true,


		//SETEO DE LAS OFERTAS
		"requestEmpresaDestino": true,
		"CVRequired": false,
		"canDuplicarOferta": true,
		"canDeleteOferta": true,
		"otrasRemuneracionesEnPracticas": true,
		"hasAnyoMaximoPromocion": true,
		"requestDatosFirmanteEnOferta": true,
		"requestDatosTutorEnOferta": true,
		"requestInfoSeleccionado": false,
		"hideOpcionesCandidatos": true,
		"showMotivoRechazo": true,
		"poblacionesDomain": true,
		"tiempoDedicacionJornada": true,
		"HistoricoOfertas": true,
		"openTitulacionesSelector": true,
		"ocultarEmpresaEnOferta": false,
		"localidadesEnDominios": true,
		"withoutEmpleo" : false,
		"adhesionprogramadirecta" : true,
		"controlProgramaEuropa" : true,
		"controlProgramaEspana" : true,
		"sumaImportesPrograma" : true,

		"camposOferta": {
			"tareas": {
				"showIn": []
			},
			"otraRemuneracion": {
				"label": "Otros beneficios",
				"showIn": ['practicas', 'practicasTitulados', 'empleo'],
				"required": false
			},
			
			
			"areaFuncional": {
				"label": "Área funcional",
				"showIn": ['practicas','practicastitulados', 'empleo'],
				"showrequired": true
			},
			"otraFormacion": {
				"label": "Otra formación",
				"showIn": ['Practicas']
			},
			"anyoMaximoPromocion": {
				"label": "Año de promoción límite",
				"showIn": []
			},
			"descripcion": {
				"label": {
					"empleo": "Descripción del puesto*",
					"practicas": "Descripción del puesto*",
					"practicastitulados": "Descripción del puesto*"
				}
			},
			"empresaDestino": {
				"showIn": ['empleo', 'practicas']
			},
			"experiencia": {
				"showIn": ['empleo'],
			},
			"motivosexclusion": {
				"showIn": ['empleo', 'practicas']
			},
			"paraEstudiantesUltimoCurso": {
				"showIn": ['practicas'],
			},
			"curricular": {
				"showIn": ['practicas'],
			},
			"ayudaEstudio": {
				"label": "Remuneración (en €)",
				"showIn": ['practicastitulados']
			},
			"urlInformacionComplementaria": true,
			"ficheroInformacionComplementaria": true
			
		},

		"camposPracticas": {
			"tareasDesglosadas": false,
			"puestoTrabajo": {
				"label": "Nombre de la práctica",
				"required": true
			},
			"tareasDesarrollar": {
				"label": "Tareas a desarrollar",
				"required": true
			},
			"datostutoruniversidad": {
				"label": "Nombre y apellidos del tutor de la Universidad",
				"required": true
			},
			"centropracticas": {
				"label": "Centro de prácticas",
				"required": false
			},
			"practicaRemunerada": {
				"label": "Práctica remunerada",
				"showIn": []
			},
			"ayudaEstudio": {
				"label": "Beca mensual",
				"disabledHide": false
			},
			
			"tutorEmpresa": {
				"cargo": true,
				"departamento": true,
				"telefono": true,
				"titulacion": false
			},
			"dastostutoruniversidad": false,
			"direccion": true,
			"numeroDiasSemana": true,
			"tiempoDedicacionJornada": true,
			"departamento": false,
			"datosFirmante":false
		},

		//REGISTRO DE LA EMPRESA
		"requestDireccionContactoEmpresa": false,
		"requestDireccionFullContactoEmpresa": false,
		"requestDireccionFacturacion": true,
		"requestTipoEmpresa": true,
		"requestTipoContacto": true,
		"hideRequestFirmanteRegistro": true,
		"requestPerfilSectorial": true,
		"checkDatosCompletosEmpresa": true,
		"infoRGDP": true,
		"registroEmpresas": {
			"sede": {
				"visible": false,
				"required": false
			},
			'otrosector': {
				"visible": false,
				"required": false
			},
			"dni": {
				"visible": true,
				"required": true
			},
		},


		//CV DEL CANDIDATO
		"canEditDeLaUniversidad": true,
		"quitarCampoDiscapacidad": true,
		"estanciaenextranjero": true,
		"hasDocumentacionLigadaProcesos": true,
		"quitarCampoNotaAcademicos": true,
		"formacionComplementaria": false,
		"competenciasProfesionales": true,
		"nivelesInformaticos": true,
		"popupDatosObligatorios": true,
		"hideMinimaRemuneracion" : true,
		"conPlanesAsociadosAlaUni" : true,
		"notaMediaPropia" : false,
		"academicos": {
			"nivelesEstudio": {
				"editable": true
			},
			"ramaTitulacion": {
				"editable": true
			},
			"certificado": {
				"editable": true
			},
			"horas": {
				"editable": true
			},
			"centro": {
				"editable": true
			},
			"nota": {
				"editable": true
			},


		},



		"personales": {
			"tipoDocumentoIdentidad": {
				"visible": true,
				"editable": true
			},
			"documentoIdentidad": {
				"visible": true,
				"editable": true
			},
			"imagen": {
				"visible": true,
				"editable": true
			},
			"nombre": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"apellido1": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"apellido2": {
				"visible": true,
				"editable": true
			},
			"email": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"telefono": {
				"visible": true,
				"editable": true
			},
			"movil": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"genero": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"generosentido": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"permisotrabajo": {
				"visible": true,
				"editable": true
			},
			"aceptaNewsletter": {
				"visible": false,
				"editable": false,
				"required": false
			},
			"fecha_nacimiento": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"password": true,
			"iban": {
				"visible": false,
				"editable": false
			},
			"SWIFT": {
				"visible": false,
				"editable": false,
				"required": false
			},
			"numeroSeguridadSocial": {
				"visible": true,
				"editable": true
			},
			"idPaisNacionalidad": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"idPaisNacimiento": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"provinciaNacimiento": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"lugarNacimiento": {
				"visible": true,
				"editable": true,
				"required": true
			},
			"direcciones": {
				"1": {
					"visible": true,
					"editable": true
				},
				"2": {
					"visible": true,
					"editable": true
				}
			}
		},

		"experiencia": {
			"descripcion": {
				"editable": true,
				"validate": 'required'
			},
			"sector": {
				"editable": true,
				"validate": 'required'
			},
			"empresa": {
				"editable": true,
				"validate": 'required'
			},
			"provincia": {
				"editable": true,
				"validate": 'required'
			},
			"duracion": {
				"editable": true,
				"validate": 'required'
			},
			"idTipoContrato": {
				"editable": true,
				"validate": 'required'
			},
			"idsubtipoContrato": {
				"editable": true,
				"validate": 'required'
			},
			"idActividadProfesional": {
				"editable": true,
				"validate": 'required'
			},
			"enlace": {
				"editable": true,
				"validate": ''
			},
			"adjunto": {
				"editable": true,
				"validate": ''
			}
		},

		"profesionales": {
			"intercambio": {
				"editable": false,
				"visible": false
			}
		},

		"interes" : {
			"empleo" :{
				"editable": true,
				"visible": true
			},
		},

		//REGISTRO DE LOS ALUMNOS
		"canRegistroAlumno": ['antiguos','estudiantes','alumnos'],
		"OneLoginForCandidatos": true,
		"hideSAML": false,
		"canBorrarCuenta": true,
		"checkDatosNecesariosEnLogin": true,
		"canRecoveryPass": true,

		//DOCUMENTACIÓN DE EMPRESAS
		"hasDocumentacionPrivadaCV": true,
		"canUploadDocEmpresas": true,
		"literalAnexosFirmados": "Documentos firmados para prácticas asignadas",
		"hideConveniosFirmados": false,
		"haveDocumentosPrograma": false,
		"haveDocumentosPracticas": true,
		"canSubirConvenios": true,
		"canCrearConvenios": true,
		"literalAnexosFirmados":false

	},
}


// WEBPACK FOOTER //
// ./src/brands/brands.js